import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Decimal from 'decimal.js';
import { FormProvider, useForm } from 'react-hook-form';
import { Tooltip, Typography } from 'seagull';
import { serviceToInput } from '~/components/ServiceBuilder/ServiceBuilder.utils';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { serviceCostModel, serviceModel } from '~/models';
import { isOneTimeInStages } from '~/models/service-billing';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import { getPriceData } from './service.utils';
import { renderDecimalDiscountTitle, renderRangeDiscountTitle } from './serviceDiscountTitles';
import { ServiceRateModalContent } from './ServiceRateModalContent/ServiceRateModalContent';
export default function ServiceRateCell(param) {
    let { index, service, isDisabled, disabledTooltip, onOpenModal } = param;
    const defaultValues = useMemo(()=>serviceToInput({
            service,
            qboItems: [],
            xeroItems: []
        }), [
        service
    ]);
    const form = useForm({
        mode: 'all',
        defaultValues
    });
    const { SERVICE_TEMPLATE_BUNDLE } = useFeatureFlags();
    const isBundle = Boolean(SERVICE_TEMPLATE_BUNDLE && serviceModel.isBundle(service));
    const onClick = ()=>{
        form.reset(defaultValues);
        onOpenModal({
            width: '450px',
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: "".concat(isBundle ? 'Bundle' : 'Service', " rate"),
                    testId: "edit-service-rate-modal-".concat(index),
                    content: /*#__PURE__*/ _jsx(FormProvider, _object_spread_props(_object_spread({}, form), {
                        children: /*#__PURE__*/ _jsx(ServiceRateModalContent, {
                            service: service,
                            draft: draft,
                            setDraft: setDraft
                        })
                    })),
                    onSubmit: (defaultBehavior)=>{
                        form.handleSubmit(defaultBehavior)();
                    }
                };
            }
        });
    };
    const { price, discountedPrice, hasDiscount } = getPriceData(service.cost);
    const isVariable = serviceCostModel.isVariablePrice(service.cost);
    const unitName = serviceCostModel.formattedUnitNameShort(service.cost);
    const error = isOneTimeInStages(service.billing) && service.cost.discount && !service.cost.discount.isPercent();
    const title = discountedPrice == null ? '' : discountedPrice instanceof Decimal ? renderDecimalDiscountTitle(discountedPrice, price, hasDiscount, isVariable, unitName, "service-rate-before-discount-".concat(index)) : renderRangeDiscountTitle(discountedPrice, price, hasDiscount, "service-rate-before-discount-".concat(index));
    const tooltipTitle = error ? 'When the billing trigger is set to ‘In stages’, the discount can only be applied as a percentage' : title;
    const discountSubheader = service.cost.discount && service.cost.discount.amount().gt(0) && service.cost.discount.format();
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-service-rate-cell-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Tooltip, {
            placement: "top",
            title: tooltipTitle,
            children: /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        skin: error ? 'error' : 'standard',
                        "aria-invalid": !!error,
                        testId: "service-rate-".concat(index),
                        ellipsis: true,
                        hideTooltip: true,
                        children: title
                    }),
                    discountSubheader && /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        skin: error ? 'error' : 'secondary',
                        testId: "service-rate-".concat(index, "-discount-subheader"),
                        children: "".concat(discountSubheader, " discount")
                    })
                ]
            })
        })
    });
}
